import { handleActions } from 'redux-actions';
import { LOCATION_CHANGE } from 'react-router-redux';
import moment from 'moment';
import _get from 'lodash/get';
import _find from 'lodash/find';
import qs from 'qs';

import endpoints from '../../../config/endpoints';
import http from '../../shared/http';
import intl from '../../shared/intl';
import { default as createCalendar } from '../../shared/calendar';

import { tableInitialState } from '../components/table/auto-trash';
import { getDateRangeFromCalendar } from '../shared/utils';

import cloneDeep from 'lodash/cloneDeep';
import values from 'lodash/values';
import createFilters from '../../shared/filters';

import createSaveExport from '../components/save-export';
import csv from 'csv-stringify';

const calendar = createCalendar({
	namespace: 'unacceptableConversions',
	stateNodeName: 'calendar',
	defaultValue: {
		start: moment().subtract(7, 'days').format('YYYY-MM-DD'),
		end: moment().format('YYYY-MM-DD')
	}
});

const saveExport = createSaveExport({
	namespace: 'unacceptableConversions'
});

const filters = createFilters({
	namespace: 'unacceptableConversions',
	stateNodeName: 'filters',
	filtersInitialState: [{
		title: 'Офферы',
		suggest: [{
			placeholder: 'Выберите оффер',
			key: 'offers',
			options: {
				source: endpoints.LOOKUPS.OFFERS,
				type: 'fromServer'
			}
		}]
	}, {
		title: 'Потоки',
		suggest: [{
			placeholder: 'Выберите поток',
			key: 'campaigns',
			options: {
				source: endpoints.STATISTICS.FILTERS.CAMPAIGNS,
				type: 'fromServer'
			}
		}]
	}, {
		title: 'Тип',
		suggest: [{
			placeholder: 'Выберите тип',
			key: 'unacceptable_conversion_types',
			options: {
				source: 'app.lists.affiliate-unacceptable-conversion-types',
				type: 'fromState'
			}
		}]
	}, {
		title: 'SubID',
		suggest: [
			{
				placeholder: 'SID1',
				key: 'sids1',
				options: { type: 'fromInput' }
			},
			{
				placeholder: 'SID2',
				key: 'sids2',
				options: { type: 'fromInput' }
			},
			{
				placeholder: 'SID3',
				key: 'sids3',
				options: { type: 'fromInput' }
			},
			{
				placeholder: 'SID4',
				key: 'sids4',
				options: { type: 'fromInput' }
			},
			{
				placeholder: 'SID5',
				key: 'sids5',
				options: { type: 'fromInput' }
			}
		]
	}]
});

const UNACCEPTABLE_CONVERSIONS_FETCH_DATA_SUCCESS = 'unacceptableConversions/fetch-data-success';
const UNACCEPTABLE_CONVERSIONS_FETCH_DATA_ERROR = 'unacceptableConversions/fetch-data-error';

const MARK_AS_VIEWED = 'unacceptableConversions/MARK_AS_VIEWED';

const CONVERSIONS_RESET = 'unacceptableConversions/reset';
const SHOW_PROGRESS_BAR = 'unacceptableConversions/show-progress-bar';

const initialState = {
	data: null,
	query: {
		currency: null,
		groups: ['date']
	},
	fullAppliedFilters: null,
	listOfCurrencies: [],
	progressBar: false,
	calendar: calendar.initialState,
	table: tableInitialState,
	filters: filters.initialState,
	error: false,
	savedFilters: saveExport.initialState
};

export const actions = Object.assign(
	{
		fetchData: props => (dispatch, getState) => {
			const query = getQuery(getState());
			const request = http({
				url: `${endpoints.STATISTICS.UNACCEPTABLE_CONVERSIONS}?${qs.stringify(query)}`,
				method: 'get',
				actions: [
					UNACCEPTABLE_CONVERSIONS_FETCH_DATA_SUCCESS,
					UNACCEPTABLE_CONVERSIONS_FETCH_DATA_ERROR
				]
			});
			return request(dispatch)
				.then((action) => {
					if (action.type === UNACCEPTABLE_CONVERSIONS_FETCH_DATA_SUCCESS) {
						dispatch(actions.markAsWatched());
					}
				});
		},
		autotrashExport: () => (dispatch, getState) => {
			const { paginatedData }  = selectors.getTableData(getState());

			if (paginatedData.length === 0) return;

			const headers = Object.keys(tableInitialState.columns);
			const columns = paginatedData.map(entity => {
				return headers.map(index => {
					return entity[index] || '-';
				});
			});

			const rows = [].concat([headers], columns);

			csv(rows, (err, res) => {
				const exportFilename = `Export--Autotrash--${moment().format(
					'YYYY-MM-DD--HH-mm-ss'
				)}.csv`;
				const csvData = new Blob([res], { type: 'text/csv;charset=utf-8;' });
				//IE11 & Edge
				if (navigator.msSaveBlob) {
					navigator.msSaveBlob(csvData, exportFilename);
				} else {
					//In FF link must be added to DOM to be clicked
					const link = document.createElement('a');
					link.href = window.URL.createObjectURL(csvData);
					link.setAttribute('download', exportFilename);
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				}
			});
		},
		markAsWatched: () => (dispatch, getState) => {
			const request = http({
				url: `${endpoints.STATISTICS.UNACCEPTABLE_CONVERSIONS}/viewed`,
				method: 'put',
				data: selectors.getDataIds(getState()),
				actions: [ MARK_AS_VIEWED ]
			});
			return request(dispatch);
		},

		statsApply: () => (dispatch, getState) => {
			dispatch(actions.showProgressBar());
			dispatch(actions.fetchData());
		},

		statsResetFromSavedFilter: () => ({ type: CONVERSIONS_RESET }),

		showProgressBar: () => ({
			type: SHOW_PROGRESS_BAR
		})
	},
	calendar.actions,
	filters.actions,
	saveExport.actions
);

const reducers = Object.assign(
	{
		[LOCATION_CHANGE]: (state, action) => {
			return { ...state, data: null };
		},
		[UNACCEPTABLE_CONVERSIONS_FETCH_DATA_SUCCESS]: (state, action) => {
			return {
				...state,
				data: action.payload.data,
				showProgressBar: false
			};
		},
		[UNACCEPTABLE_CONVERSIONS_FETCH_DATA_ERROR]: (state, action) => ({
			...state, data: null, error: true, showProgressBar: false
		})
	},
	calendar.reducers,
	saveExport.reducers,
	filters.reducers
);

export default handleActions(reducers, cloneDeep(initialState));

export const selectors = {
	getData: state => state.unacceptableConversions.data,
	getIsShowedAutoTrash: state => _get(state, 'app.userData.general.feature_flags.autotrash', false),
	getAutotrashType: state => _get(state, 'app.lists.affiliate-unacceptable-conversion-types', []),
	getDataIds: state => {
		return state.unacceptableConversions.data &&
			state.unacceptableConversions.data.map(item => item.id);
	},
	getProgressBar: state => state.unacceptableConversions.showProgressBar,
	getTableData: state => {
		const types = selectors.getAutotrashType(state);
		const data = state.unacceptableConversions.data;
		return {
			tableHeaders: values(state.unacceptableConversions.table.columns),
			paginatedData: data && data.map(item => ({
				...item, type: _find(types, { id: item.type_id })
			}))
		};
	},
	getError: state => state.unacceptableConversions.error,
	getFilters: state => filters.selectors.selectFilters(
		state => state.unacceptableConversions.filters, state => state
	)(state),
	getAppliedFilters: state => filters.selectors.appliedFilters(state),
	getCalendar: state => calendar.selectors.getCalendar(
		state => state.unacceptableConversions.calendar, state => state
	)(state),
	getIntl: intl
};

function getQuery(state) {
	const filters =  selectors.getAppliedFilters(state);
	const query = { date_range: getDateRangeFromCalendar(selectors.getCalendar(state)) };

	if (filters && filters.length) {
		query.filters = filters
			.map(item => ({ ...item, suggestId: item.suggestId.replace('sids', 'sid') }))
			.reduce((acc, value) => {
				acc[value.suggestId] = (acc[value.suggestId] || []).concat([ value.itemId ]);
				return acc;
			}, {});
	}

	return query;
}


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/statistics/ban/index.js